// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"d98f8357","26":"87dd2529","52":"efcb2183","490":"169d7d46","680":"1d246eb0","785":"17e8fd90","797":"fd017d70","842":"826dba35","882":"2ade7078"}[chunkId] + ".chunk.js";
};